export default {
	info: 'Info',
	modal: {
		title: 'Explanation of Role Permissions',
		p1: 'Permissions determine what a user can see and do in the Cybsis software.',
		p2: 'Permissions are granted to users through roles: first, a new role is created, then permissions are selected for the role, and finally, the user is assigned to that role.',
		actionsTitle: 'There are four main actions:',
		actions: {
			view: 'View (including exporting)',
			edit: 'Edit',
			add: 'Add',
			delete: 'Delete',
		},
		permissionsTitle: 'Permissions are divided into two types:',
		own: 'Own: You can perform actions on objects for which the user/role is designated as responsible.',
		all: 'All: You can perform actions on all data.',
		legend: 'An X indicates lack of permission, and ON indicates that the permission to use the functionality is enabled.',
		example:
			'Example: If an asset is linked to a business process, and the responsible person for the business process has OWN view rights for assets, they will also be able to see that asset.',
		autoRights1: 'Automatic responsible permissions',
		autoRights2:
			' — if a user is responsible for something (such as a business process, module, or asset/information asset), the responsible person can see related data if they have at least OWN viewing permissions for those linked objects.',

		admin1: 'Administrator permissions',
		admin2: ' are separate permissions that include general software settings.',
	},
	missingRights: 'Missing rights',
}
